// AGC: Segmented control for the analytics dashboard's date range filter.
// AGC: Renders 4 preset buttons (24h / 7d / 30d / 90d); active button is highlighted in emerald.
import type { DateRange } from '../../../services/analyticsQueryService'

// AGC: Ordered list of date range options shown in the segmented control
const RANGES: ReadonlyArray<{ value: DateRange; label: string }> = [
  { value: '24h', label: '24h' },
  { value: '7d',  label: '7d'  },
  { value: '30d', label: '30d' },
  { value: '90d', label: '90d' },
]

export interface DateRangeSelectorProps {
  value: DateRange
  onChange: (value: DateRange) => void
  className?: string
}

export function DateRangeSelector({ value, onChange, className }: DateRangeSelectorProps): JSX.Element {
  return (
    <div
      className={`inline-flex rounded-lg border border-slate-200 dark:border-white/5 bg-white dark:bg-admin-card-dark p-1 ${className ?? ''}`}
      role="group"
      aria-label="Date range"
    >
      {RANGES.map((r) => {
        const isActive = r.value === value
        return (
          <button
            key={r.value}
            type="button"
            onClick={() => onChange(r.value)}
            aria-pressed={isActive}
            className={
              `px-3 py-1 rounded-md text-sm font-medium transition-colors ` +
              (isActive
                ? 'bg-emerald-500 text-white'
                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/5')
            }
          >
            {r.label}
          </button>
        )
      })}
    </div>
  )
}
